import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface SimpleLanguageSelectorProps {
  className?: string;
}

const SimpleLanguageSelector: React.FC<SimpleLanguageSelectorProps> = ({ className = '' }) => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    changeLanguage(event.target.value);
  };

  return (
    <label className={['navbar-lang-select', className].filter(Boolean).join(' ')}>
      <span className="material-icons navbar-lang-icon" aria-hidden="true">language</span>
      <select
        value={currentLanguage}
        onChange={handleLanguageChange}
        aria-label="Select language"
      >
        {availableLanguages.map((language) => (
          <option key={language.code} value={language.code}>
            {language.code.toUpperCase()}
          </option>
        ))}
      </select>
    </label>
  );
};

export default SimpleLanguageSelector;
